module.exports = __webpack_public_path__ + "img/doc3.e3e03a50.png";